import { AppError, EipError } from 'src/redux/types';
export const formatErrorMessage = error => {
  if (!error) return undefined;

  switch (error) {
    case EipError.USER_REJECTED_REQUEST:
      return {
        title: 'Opps! Something went wrong',
        description: 'Transaction has been canceled'
      };

    case EipError.INVALID_ADDRESS:
      return {
        title: 'Opps! Something went wrong',
        description: 'The currently used wallet differs from the linked account wallet'
      };

    case AppError.INSUFFICIENT_BALANCE:
      return {
        description: 'Insufficient balance',
        title: 'Opps! Something went wrong'
      };

    case AppError.HERO_HAS_BEEN_RENTED:
      return {
        description: 'Sorry, this item is no longer available',
        title: 'Opps! Something went wrong'
      };

    default:
      return {
        title: 'Opps! Something went wrong',
        description: `Error code: ${error}`
      };
  }
};